import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getMockAddress } from '@utils/mockUtils';
import urlList from '@utils/urlList';
import * as actions from '@redux-actions/';
import { handleHTTPError } from '@utils/utils';

/* ADDRESS */
export const getAddress = (mockRequests: boolean, hostname: string, orderId: string) => {
    return (dispatch) => {
        const url = hostname + urlList['GET_ADDRESS'] + '/' + orderId + '?nocache=' + new Date().getTime();
    
        return (mockRequests 
            ? getMockAddress()
            : axios({
                url,
                method: 'GET',
                withCredentials: true,
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            })
        )
            .then((res: any) => {
                const address = extrapolateAddressData(res.data);
                let filteredAddresses = null;
                if(!!res.data && !!res.data.resultList && res.data.resultList.length > 0 && res.data.resultList[0].billingAddresses.length > 0)
                    filteredAddresses = res.data.resultList[0].billingAddresses.filter(address => (!!address.addressType && address.addressType == 'SB'));
                dispatch(getAllBillingAddresses(!!filteredAddresses && filteredAddresses.length > 0 ? filteredAddresses : []));
                dispatch(getAddressSuccess(address));
            })
            .catch((err) => {
                console.error('>>> Get address => error status:', err.status, ', error: ', err);
                handleHTTPError(dispatch, actions, err.response);
                dispatch(getAddressFailure());
            })
    }
}

const getAddressSuccess = (address) => {
    return {
        type: actionTypes.GET_ADDRESS_SUCCESS,
        address
    }
}
const getAddressFailure = () => {
    return {
        type: actionTypes.GET_ADDRESS_FAILURE
    }
}

export const setAddress = (address) => {
    return {
        type: actionTypes.SET_ADDRESS,
        address
    }
}

export const getAllBillingAddresses = (allBillingAddresses) => {
    return {
        type: actionTypes.GET_ALL_BILLING_ADDRESSES,
        allBillingAddresses
    }
}

const extrapolateAddressData = (data) => {   
    const billingAddress = !!data.resultList[0].orderDataBean.billingAddressDataBean ? data.resultList[0].orderDataBean.billingAddressDataBean : {};
    
    let deliveryAddress;

    if(
        !!data.resultList[0].orderDataBean &&
        !!data.resultList[0].orderDataBean.uniqueShippingAddresses &&
        data.resultList[0].orderDataBean.uniqueShippingAddresses.length > 0 &&
        data.resultList[0].orderDataBean.uniqueShippingAddresses[0] !== null
    ) {
        deliveryAddress = data.resultList[0].orderDataBean.uniqueShippingAddresses[0];
    } else {
        deliveryAddress = {};
    }

    return {
        "deliveryAddress": {
            "email1": deliveryAddress.email1,
            "firstName": deliveryAddress.firstName,
            "lastName": deliveryAddress.lastName,
            "address1": deliveryAddress.address1,
            "address2": deliveryAddress.address2,
            "city": deliveryAddress.city,
            "state": deliveryAddress.state,
            "zipCode": deliveryAddress.zipCode,
            "phone1": deliveryAddress.phone1,
            "country": "US",
        },
        "billingAddress": {
            "email1": billingAddress.email1,
            "firstName": billingAddress.firstName,
            "lastName": billingAddress.lastName,
            "address1": billingAddress.address1,
            "address2": billingAddress.address2,
            "city": billingAddress.city,
            "state": billingAddress.state,
            "zipCode": billingAddress.zipCode,
            "phone1": billingAddress.phone1,
            "country": "US",
        },
        "deliveryAddressId": !!deliveryAddress.addressId ? deliveryAddress.addressId : null,
        "billingAddressId": !!billingAddress.addressId ? billingAddress.addressId : null
    }
}